var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"department-main"},[_c('div',{staticClass:"department-item"},[_c('div',{staticClass:"department-key"},[_vm._v("组织架构:")]),_c('div',{staticClass:"department-val"},[_c('b-organize-department',{attrs:{"isEdit":"","isInit":""},on:{"success":_vm.getDepartmentActiveList}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }